module.exports = __webpack_public_path__ + "img/solar.3c722498.jpg";